module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IArs4c6QAAAHJQTFRFAAAAAFX/AFXVAG3bFWrVFGLYEm3bEGDfDWjZDGfXDGjXDGfYDGbYDGjYC2jYC2fYC2bYC2fYDGbZDGfXDGfZDGfYDGbYDGfYDGfYDGfYDGfYDGbZC2fYDWbYDGfYDGfYDGfYDGfYDGfYDGfYDGfYDGfYMJCZbAAAACV0Uk5TAAMGBwwNDhBRUlNUVVZbXImKk5Smq6zX2Nna29/g4+Ty8/j5+ktJhLsAAACdSURBVBgZXcGLFkJQEAXQ4xaayKMkz1Sc///FzLCssjeMuxTd+H4UscPm1HLVChZexh+ZB5XxT4ZZxJ0IcE/uDA4JTSNBIA1NijtVHWIWVlQleiqBEaoeH6oAxqca8aIKYI5UI2oqgRGqHneqKsQsrKhKJDSN+L7UNCnckzvDAYi5E2OW808O5V354+ZhcW65aiNsXFJ209SViYP6AqNRJW4O1WrLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circular@2x.png
// module id = 8IHL
// module chunks = 1